<mat-tab-group
  class="tab-header box-tab size-{{ Size }}"
  [selectedIndex]="selectedIndex"
  (selectedIndexChange)="onTabChange($event)"
  mat-stretch-tabs>
  <mat-tab *ngFor="let tab of boxContent; let i = index" [disabled]="tab.disabled">
    <ng-template mat-tab-label>
      <span
        class="d-flex align-items-center spacing-4 w-100 box-padding"
        matTooltip="{{ tab.tooltip }}"
        matTooltipPosition="above">
        <span class="h4-case">
          <app-ce-icon [name]="tab.icon" [svg_class]="['d-flex', 'primary-100']"> </app-ce-icon>
        </span>
        @if (showLabel) {
          <span class="visually-visible h4-case">{{ tab.label }}</span>
        }
      </span>
    </ng-template>
    <ng-container *ngTemplateOutlet="tabTemplates[tab.id]"></ng-container>
  </mat-tab>
</mat-tab-group>
